import React from "react";
import Logo from "../assets/img/brand/instructionLogo.png";

const TalkingPreview = ({ data }) => {
  const appealingVideo = data?.appealingVideo;
  const introducingVideo = data?.introducingVideo;

  const getImageBlobUrl = (imageFile) => {
    if (imageFile) {
      const blobUrl = URL.createObjectURL(imageFile);
      return blobUrl;
    }
    return null;
  };

  return (
    <div>
      <div className="border border-dark p-3" style={{ borderWidth: "2px" }}>
        <div className="">
          <div className="d-flex">
            <div className="w-25">
              <img src={data.athleteImg} height={100} width={100} />
            </div>
            <div className="w-75 text-right ">
              <img
                src={Logo}
                height={17}
                width={170}
                className="mr-sm-3 mr-md-3 fanImg"
              />
              <div className="athleteName">
                <h2
                  className="text-center line-height mt-2 "
                  style={{ lineHeight: "15px" }}
                >
                  {data?.firstName}
                </h2>
                <h2 className="text-center" style={{ lineHeight: "13px" }}>
                  {data?.lastName}
                </h2>
              </div>
              <h5 className="text-center desText">{data?.description}</h5>
            </div>
          </div>
          <div className="d-flex mt-3 cardImages">
            <div className="w-20">
              <img
                src={
                  data.introducingVideo instanceof File
                    ? getImageBlobUrl(introducingVideo)
                    : data.introducingVideo
                }
                height={100}
                width={100}
              />
            </div>
            <div className="w-50 text-center mt-3">
              <h2 className="font-weight-bold">Talking</h2>
              <h2 className="font-weight-bold">Badges</h2>
            </div>
            <div className="w-20">
              <img
                src={
                  data.appealingVideo instanceof File
                    ? getImageBlobUrl(appealingVideo)
                    : data.appealingVideo
                }
                height={100}
                width={100}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TalkingPreview;
